import { Component, OnInit } from '@angular/core';
import { SharedService} from 'src/app/shared.service'
import { MatSnackBar } from '@angular/material';
import { NzFormModule } from 'node_modules/ng-zorro-antd/form';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.css']
})
export class ContactFormComponent implements OnInit {

  options = ['one','two','three']


  contactDetailsForm: FormGroup;
  
  constructor(private fb: FormBuilder, private share:SharedService, private _snackBar:MatSnackBar ) { }

  ngOnInit() {

    this.contactDetailsForm = this.fb.group({
      firstName: ["", [Validators.required]],
      lastName: ["", [Validators.required]],
      email: ["", [Validators.required]],
      contactNumber: ["", [Validators.required]],
      selectedOption:["", [Validators.required]],
      message:["", [Validators.required]]
    })
  }

  onSubmit(){
    for (const i in this.contactDetailsForm.controls) {
      this.contactDetailsForm.controls[i].markAsDirty();
      this.contactDetailsForm.controls[i].updateValueAndValidity();
    }

    if(this.contactDetailsForm.valid){
      this.share.postContact(this.contactDetailsForm.value).subscribe((a)=>{
        console.log(a,'contact send');
        this._snackBar.open('Contact send ', 'Okay', {
          duration: 5000,
        });
      })
     }else{
      // this._snackBar.open('please enter all fields ', 'Okay', {
      //   duration: 5000,
      // });
    }
  }

  onChange(event){
    this.contactDetailsForm.value.firstName = String(this.contactDetailsForm.value.firstName).trim().replace(/\s\s+/g, ' ');
    this.contactDetailsForm.value.lastName = String(this.contactDetailsForm.value.lastName).trim().replace(/\s\s+/g, ' ');
    this.contactDetailsForm.value.email = String(this.contactDetailsForm.value.email).trim().replace(/\s\s+/g, ' ');
    this.contactDetailsForm.value.contactNumber = String(this.contactDetailsForm.value.contactNumber).trim().replace(/\s\s+/g, ' ');
    this.contactDetailsForm.value.message = String(this.contactDetailsForm.value.message).trim().replace(/\s\s+/g, ' ');
  }

}
